module.exports = __webpack_public_path__ + "media/bootstrap-icons/hdd-network-b5fd2b14.svg";